import Vue from 'vue'

const state = {
  sales: {
    completed: []
  },
  purchase: {
    queue: [],
    completed: []
  },
  checklist: null
}

const getters = {
  purchasesQueue: (state) => state.purchase.queue,
  purchasesCompleted: (state) => state.purchase.completed,
  salesCompleted: (state) => state.sales.completed,
  checklist: (state) => state.checklist
}

const actions = {
  async generatePurchaseInvoice (state, invoice) {
    await Vue.http.post('/generate/purchase', invoice)
  },
  async generatePurchaseInvoiceAndSend ({dispatch}, invoice) {
    await Vue.http.post('/generate/purchase', invoice)
  },
  async sendPurchaseInvoice (state, id) {
    await Vue.http.post('/send/purchase', {id})
  },
  async getPurchasesCompleted ({commit}) {
    const {body} = await Vue.http.get('/purchases/completed')
    commit('setPurchasesCompleted', body.data)
  },
  async generateCheckList ({commit}, {startDate, endDate}) {
    const {body} = await Vue.http.post('/checklist', {startDate, endDate})
    commit('setChecklist', body.data.id)
  },
  async getPurchasesQueue ({commit}) {
    const {body} = await Vue.http.get('/purchases/queue')
    commit('setPurchasesQueue', body.data)
  },
  async rejectPurchase ({dispatch}, id) {
    await Vue.http.delete(`/purchase/${id}`)
    dispatch('getPurchasesQueue')
  },
  async creditNotePurchaseReceipt ({dispatch}, { receipt, purchase }) {
    await Vue.http.post('/credit/purchase/receipt', { receipt, purchase })
    await dispatch('getPurchasesCompleted')
  },
  async creditNotePurchase ({dispatch}, id) {
    await Vue.http.post('/credit/purchase', { id })
    await dispatch('getPurchasesCompleted')
  },
  async createSalesInvoiceAndSend (state, invoice) {
    await Vue.http.post('/sale', invoice)
  },
  async createInvoicesAndSend (state, invoices) {
    await Vue.http.post('/invoices', invoices)
  },
  async getSalesCompleted ({commit}) {
    const {body} = await Vue.http.get('/sales')
    commit('setSales', body.data)
  },
  async creditNoteSale ({dispatch}, id) {
    await Vue.http.post('/credit/sale', { id })
    await dispatch('getSalesCompleted')
  },
  async saleInProgress ({commit}, id) {
    commit('setProgessSale', id)
  },
  async saleCompletedProgress ({commit}, id) {
    commit('unsetProgressSale', id)
  }
}

const mutations = {
  setPurchasesQueue (state, purchases) {
    state.purchase.queue = purchases
  },
  setPurchasesCompleted (state, purchases) {
    state.purchase.completed = purchases
  },
  setSales (state, sales) {
    state.sales.completed = sales
  },
  setChecklist (state, checklist) {
    state.checklist = checklist
  },
  setProgessSale (state, id) {
    const index = state.sales.completed.findIndex((sale) => {
      return sale.id === id
    })

    state.sales.completed[index].inprogress = true
  },
  unsetProgressSale (state, id) {
    const index = state.sales.completed.findIndex((sale) => {
      return sale.id === id
    })

    state.sales.completed[index].inprogress = false
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/invoices.js